exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:600px){.src-components-order-styles-___list-item__mt10sm___1I5I2{margin-top:10px}}@media (min-width:600px){.src-components-order-styles-___list-item__lgNoPadding___BRLJg{padding-left:0;padding-right:0}}.src-components-order-styles-___list-item__total___1Zo2s{color:#b18433}", ""]);

// exports
exports.locals = {
	"mt10sm": "src-components-order-styles-___list-item__mt10sm___1I5I2",
	"lgNoPadding": "src-components-order-styles-___list-item__lgNoPadding___BRLJg",
	"total": "src-components-order-styles-___list-item__total___1Zo2s"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/order/styles/list-item.scss
 ** module id = 891
 ** module chunks = 0
 **/